import { Component, Input } from '@angular/core';
import { TopTab } from '../button-detail-list-larger/button-detail-list-larger.types';

@Component({
    selector: 'button-detail-list-section',
    templateUrl: './button-detail-list-section.component.html',
})
export class ButtonDetailListSectionComponent {
    @Input() tabs: TopTab[] = [];
    @Input() heading = '';
    @Input() hideTabs = true;
}
